<template>
  <pt-counselor-detail class="pt-counselor-detail__withData" v-loading="loading" :counselor="counselor" :userFullName="userFullName" :userId="userId"
                       @createQrCode="createQrCode" :qrCodeLoading="qrCodeLoading"></pt-counselor-detail>
</template>

<script>
import PtCounselorDetail from './index'
export default {
  name: 'pt-counselor-detail__withData',
  components: {
    'pt-counselor-detail': PtCounselorDetail
  },
  data () {
    return {
      counselor: {},
      userId: this.$route.params.id,
      userFullName: '',
      loading: false,
      qrCodeLoading: false
    }
  },
  methods: {
    load (id) {
      this.loading = true
      this.$store.dispatch('getCounselor', id).then(data => {
        this.loading = false
        this.counselor = data
        if (this.counselor.userLogin) {
          this.$store.dispatch('getUserByLogin', this.counselor.userLogin).then(res => {
            console.log('---------', res)
            this.userId = res.data.id
            this.userFullName = res.data.fullName
          }).catch(err => {
            this.$message.error(err || '获取咨询师详情失败')
          })
        }
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    createQrCode () {
      this.qrCodeLoading = true
      this.$store.dispatch('getCounselorQrCode', this.$route.params.id).then(res => {
        this.qrCodeLoading = false
        this.$message.success('生成二维码成功')
      }).catch(err => {
        this.qrCodeLoading = false
        this.$message.error(err || '生成二维码失败')
      })
    }
  },
  created () {
    if (this.$route.params.id) {
      this.load(this.$route.params.id)
    }
  }
}
</script>
